import { LongTermHousingRentals } from './components';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return <LongTermHousingRentals />;
}

export default App;
